/**
 * CSRF Token Yönetimi
 * Token'ı localStorage'da saklar ve API isteklerinde kullanır
 */

import { getApiUrl, API_ENDPOINTS } from '../config/apiConfig';

const CSRF_TOKEN_KEY = 'csrf_token';
const CSRF_TOKEN_EXPIRY = 'csrf_token_expiry';
const TOKEN_EXPIRY_TIME = 55 * 60 * 1000; // 55 dakika (token 1 saat geçerli)

/**
 * CSRF token'ı alır (cache'den veya API'den)
 * @returns {Promise<string>}
 */
export const getCsrfToken = async () => {
  // Cache'den kontrol et
  const cachedToken = localStorage.getItem(CSRF_TOKEN_KEY);
  const cachedExpiry = localStorage.getItem(CSRF_TOKEN_EXPIRY);
  
  if (cachedToken && cachedExpiry) {
    const expiryTime = parseInt(cachedExpiry, 10);
    const now = Date.now();
    
    // Token hala geçerliyse cache'den döndür
    if (now < expiryTime) {
      return cachedToken;
    }
  }
  
  // Token yoksa veya expire olmuşsa API'den al
  try {
    const response = await fetch(getApiUrl(API_ENDPOINTS.GET_CSRF_TOKEN), {
      credentials: 'include'
    });
    
    if (!response.ok) {
      throw new Error('Failed to fetch CSRF token');
    }
    
    const data = await response.json();
    
    if (data.success && data.csrf_token) {
      // Token'ı cache'le
      const expiryTime = Date.now() + TOKEN_EXPIRY_TIME;
      localStorage.setItem(CSRF_TOKEN_KEY, data.csrf_token);
      localStorage.setItem(CSRF_TOKEN_EXPIRY, expiryTime.toString());
      
      return data.csrf_token;
    }
    
    throw new Error('Invalid CSRF token response');
  } catch (error) {
    console.error('Error fetching CSRF token:', error);
    // Hata durumunda boş string döndür (CSRF kapalı olabilir)
    return '';
  }
};

/**
 * CSRF token'ı temizler (logout vb. durumlarda)
 */
export const clearCsrfToken = () => {
  localStorage.removeItem(CSRF_TOKEN_KEY);
  localStorage.removeItem(CSRF_TOKEN_EXPIRY);
};

/**
 * CSRF token'ı response'dan alıp cache'ler (login/register sonrası)
 * @param {string} token
 */
export const setCsrfToken = (token) => {
  if (token) {
    const expiryTime = Date.now() + TOKEN_EXPIRY_TIME;
    localStorage.setItem(CSRF_TOKEN_KEY, token);
    localStorage.setItem(CSRF_TOKEN_EXPIRY, expiryTime.toString());
  }
};

/**
 * Mevcut token'ı döndürür (async değil, cache'den)
 * @returns {string|null}
 */
export const getCachedCsrfToken = () => {
  const cachedToken = localStorage.getItem(CSRF_TOKEN_KEY);
  const cachedExpiry = localStorage.getItem(CSRF_TOKEN_EXPIRY);
  
  if (cachedToken && cachedExpiry) {
    const expiryTime = parseInt(cachedExpiry, 10);
    const now = Date.now();
    
    if (now < expiryTime) {
      return cachedToken;
    }
  }
  
  return null;
};

